import { george, pr, theme, ui } from "aaa";
import { observer } from "mobx-react";
import { customColors } from "muiTheme";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { isMobile } from "util/helpers";

type ScreenWithBottomActionProps = {
    children: React.ReactNode;
    title?: string;
    ContinueButton?: React.ReactNode;
    CancelButton?: React.ReactNode;
    isLoading?: boolean;
};

export const ScreenWithBottomAction = observer(
    ({
        children,
        title,
        ContinueButton,
        CancelButton,
        isLoading,
    }: ScreenWithBottomActionProps) => {
        const BackgroundComponent = externalInterfaceStore.isGeorgeApp
            ? george.Background
            : george.BackgroundWithNavBar;
        const backgroundColor = ui.isDarkMode
            ? "#14141A"
            : customColors.georgeJuniorBackground;
        const backgroundStyle: React.CSSProperties = {
            background: backgroundColor,
            paddingTop: theme.MARGIN,
            paddingBottom: theme.MARGIN,
        };

        if (isLoading) {
            return (
                <BackgroundComponent style={backgroundStyle}>
                    <george.LoadingIndicator
                        isLoading={isLoading}
                        height={ui.windowHeight}
                    />
                </BackgroundComponent>
            );
        }

        return (
            <BackgroundComponent style={backgroundStyle}>
                <george.PageWithActionButton>
                    <div
                        style={{
                            margin: "0 16px",
                            paddingBottom: isMobile() ? 150 : 0,
                        }}
                    >
                        {title && (
                            <pr.P_28_TITLE
                                style={{
                                    fontWeight: 700,
                                    marginTop: theme.MARGIN,
                                }}
                            >
                                {title}
                            </pr.P_28_TITLE>
                        )}
                        {children}
                    </div>

                    <div
                        style={{
                            position: "fixed",
                            bottom: 0,
                            width: "100%",
                            height: isMobile()
                                ? theme.ACTION_BUTTON_HEIGHT * 2 + theme.MARGIN
                                : 0,
                        }}
                    >
                        {ContinueButton}
                        {CancelButton}
                    </div>
                </george.PageWithActionButton>
            </BackgroundComponent>
        );
    },
);



// WEBPACK FOOTER //
// ./src/components/gJunior/components/ScreenWithBottomAction.tsx